import type { IBuilderReturnData } from '../types';
import type { MarketIdentifiers } from '$lib/types/market';
import { cancelStandardOrder } from '../connectors/orders';
import { closeFullTrade } from '../connectors/trade';

export const buildCancelTradeSmartContract = async (
	marketIdentifier: MarketIdentifiers
): Promise<IBuilderReturnData> => {
	const targetArray: Array<string> = [];
	const callDataArray: Array<string> = [];

	const cancelTradeSmartContractCallData = await cancelStandardOrder(marketIdentifier);

	targetArray.push(cancelTradeSmartContractCallData._target);
	callDataArray.push(cancelTradeSmartContractCallData._callData);

	return {
		_targetArray: targetArray,
		_callDataArray: callDataArray
	};
};

export const buildCloseFullTradeSmartContract = async (
	marketIdentifier: MarketIdentifiers,
	priceImpact: string
): Promise<IBuilderReturnData> => {
	const targetArray: Array<string> = [];
	const callDataArray: Array<string> = [];

	const closeFullTradeSmartContractCallData = await closeFullTrade(marketIdentifier, priceImpact);

	targetArray.push(closeFullTradeSmartContractCallData._target);
	callDataArray.push(closeFullTradeSmartContractCallData._callData);

	return {
		_targetArray: targetArray,
		_callDataArray: callDataArray
	};
};
